import React from 'react';
import { WrappedCard } from '../WrappedCard';

interface MinedWithDaisyCardProps {
  username?: string;
  totalWingoMined: number;
}

export const MinedWithDaisyCard: React.FC<MinedWithDaisyCardProps> = ({ username, totalWingoMined }) => {
  return (
    <WrappedCard className="relative" username={username} noContainer={true}>
      <div className="space-y-3 md:space-y-4 relative z-10">
        {/* Daisy Wingate image - full width, no double border */}
        <div className="flex justify-center mb-3 md:mb-4">
          <div className="relative" style={{ maxWidth: '100%', width: 'fit-content' }}>
            <div className="absolute inset-0 bg-yellow-400 blur-3xl opacity-40 animate-pulse rounded-2xl"></div>
            <img
              src="/daisy_wingate_2.png"
              alt="Coach DAISY"
              className="relative rounded-2xl border-4 border-yellow-400 shadow-2xl"
              style={{ 
                maxHeight: '400px', 
                maxWidth: '100%',
                height: 'auto',
                width: 'auto',
                objectFit: 'contain',
                display: 'block'
              }}
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.style.display = 'none';
              }}
            />
          </div>
        </div>
        
        <div className="bg-black/60 backdrop-blur-md rounded-2xl p-4 md:p-5 border-2 border-yellow-400/50 shadow-2xl">
          <p className="text-lg md:text-xl lg:text-2xl text-yellow-200 font-bold text-center">
            <span className="bg-gradient-to-r from-yellow-300 to-amber-200 bg-clip-text text-transparent">Coach DAISY</span> was your top WINGO partner—joining you for {totalWingoMined.toLocaleString()} of your {totalWingoMined.toLocaleString()} Wingos.
          </p>
        </div>
      </div>
    </WrappedCard>
  );
};

